import { useMemo } from 'react';
import { mergeClassNames } from 'utils/helpers';
import { v4 as uuidv4 } from 'uuid';

interface IProps {
  stepCount: number;
  currentStep: number;
  status?: 'DONE' | 'ERROR';
}

type Dot = {
  index: number;
  id: string;
};

const StepIndicator = ({ stepCount, currentStep, status }: IProps) => {
  const dots = useMemo(() => {
    const renderSteps = [];

    for (let i = 1; i <= stepCount; i++) {
      renderSteps.push({
        index: i,
        id: uuidv4()
      });
    }

    return renderSteps;
  }, [stepCount]);

  const stepDone = (dot: Dot) =>
    currentStep > dot.index || (currentStep === dot.index && status === 'DONE');
  const stepError = (dot: Dot) => currentStep === dot.index && status === 'ERROR';

  return (
    <div className="flex justify-center">
      {dots.map((dot) => (
        <div
          key={dot.id}
          className={mergeClassNames(
            'w-5 h-5 border-2 rounded-full mx-2 border-darkBlue-5 flex justify-center items-center font-bold text-white',
            {
              'border-lightBlue-100': currentStep >= dot.index,
              'bg-lightBlue-100': stepDone(dot),
              'bg-lightRed-100 border-lightRed-100': stepError(dot)
            }
          )}
        >
          {stepDone(dot) ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 18 14"
              className="w-4 h-4"
            >
              <path
                fill="currentColor"
                d="M6 10.67 2.53 7.2a.996.996 0 1 0-1.41 1.41l4.18 4.18c.39.39 1.02.39 1.41 0L17.29 2.21A.996.996 0 1 0 15.88.8L6 10.67Z"
              />
            </svg>
          ) : null}
          {stepError(dot) ? <span>!</span> : null}
        </div>
      ))}
    </div>
  );
};

export default StepIndicator;
